import React, { Fragment, useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import styled from 'styled-components'
import { Form, Field } from '@progress/kendo-react-form'
import { Button } from '@progress/kendo-react-buttons'
import { Input } from '@progress/kendo-react-inputs'
import { fetchLanguages, fetchUsers, loginUser, validateToken } from '../store/actions'
import config from '../config'
import { Loader } from '../components'
import Typography from '@material-ui/core/Typography'

export default () => {
    const dispatch = useDispatch()
    const [cookies] = useCookies([config.sso.COOKIE_NAME])
    const samlCookie = cookies[config.sso.COOKIE_NAME]
    const [error, setError] = useState(false)

    if (samlCookie === undefined && config.sso.ENABLED) {
        useEffect(() => {
            axios.get(`${config.sso.IDP_ENDPOINT}?returnToOnSuccess=${config.app.URL}`)
                .then(response => response.data)
                .then(({ ssourlwithAuthNRequest }) => {
                    window.location.href = ssourlwithAuthNRequest
                })
                .catch(() => {
                    setError(true)
                })
        }, [])
    } else if (config.sso.ENABLED) {
        dispatch(loginUser(samlCookie))
            .then((response) => {
                if (!response.payload.user) {
                    setError(true)
                    return Promise.resolve(null)
                }
                return Promise.all([dispatch(fetchLanguages()), dispatch(fetchUsers())])
            })
            .catch(() => {
                setError(true)
            })
    }

    const handleSubmit = ({ code }) => {
        dispatch(validateToken(code))
            .then(() => Promise.all([dispatch(fetchLanguages()), dispatch(fetchUsers())]))
    }

    return error
        ? <MessageWrapper>
            <Typography variant="h4">Sie konnten nicht angemeldet werden.<br/>Bitte wenden Sie sich an den
                Support.</Typography>
        </MessageWrapper>
        : config.sso.ENABLED
            ? <Loader/>
            : <Wrapper>
                <Form onSubmit={handleSubmit} render={(formRenderProps) => (
                    <Fragment>
                        <Field component={Input} name="code" onKeyUp={(e) => {
                            if (e.which === 13) formRenderProps.onSubmit()
                        }}/>
                        <Button primary onClick={formRenderProps.onSubmit}>Absenden</Button>
                    </Fragment>)}/>
            </Wrapper>
}

const Wrapper = styled.div`
    display: block;
    flex: 1;
    margin: 20px 40px;
`

const MessageWrapper = styled.div`
    margin-top: 300px;
    text-align: center;
    width: 100%
`



// WEBPACK FOOTER //
// ./src/pages/Login.js